import { useCallback } from "react";
import { useSelector } from "react-redux";
import { getQueryData } from "src/helpers/helpers";
import useFetchAsync from "src/hooks/useFetchAsync";
import {
  deleteReq,
  patch,
  useGet,
  usePatch,
  usePost,
} from "src/http-clients/clients";
import { getActiveStoreId } from "src/redux/selectors/app";

export const useCreatePackage = () => {
  const activeStore = useSelector(getActiveStoreId);
  return usePost(`/users/stores/${activeStore}/packages/create`);
};

export const useGetPackages = ({
  length,
  page,
  search,
}: {
  length?: number;
  page?: number;
  search?: string;
}) => {
  const activeStore = useSelector(getActiveStoreId);
  let offset;
  if (page && length) {
    offset = page === 1 ? 0 : (page - 1) * length;
  }
  const queryData = getQueryData({ length, offset, search });
  const data = useGet(
    offset === undefined
      ? `/users/stores/${activeStore}/packages/list`
      : `/users/stores/${activeStore}/packages/list${queryData}`
  );
  return data;
};

export const useGetPackageData = (packageId: number) => {
  const activeStore = useSelector(getActiveStoreId);
  return useGet(
    packageId ? `/users/stores/${activeStore}/packages/${packageId}` : null
  );
};

export const useUpdatePackage = (packageId: number) => {
  const activeStore = useSelector(getActiveStoreId);
  return usePatch(`/users/stores/${activeStore}/packages/${packageId}`);
};

export const useDeletePackage = () => {
  const activeStore = useSelector(getActiveStoreId);
  const deleteData = useCallback(
    (packageId: number) => {
      return deleteReq(`/users/stores/${activeStore}/packages/${packageId}`);
    },
    [activeStore]
  );
  return useFetchAsync(deleteData);
};

export const useUpdatePackageStatus = () => {
  const activeStore = useSelector(getActiveStoreId);
  const handleStatusChange = useCallback(
    (packageId: number, status: boolean) => {
      return patch(
        `/users/stores/${activeStore}/packages/${packageId}/status`,
        {
          status,
        }
      );
    },
    [activeStore]
  );
  return useFetchAsync(handleStatusChange);
};
